import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "stats-container" }
const _hoisted_3 = { class: "stat-icon" }
const _hoisted_4 = { class: "stat-content" }
const _hoisted_5 = { class: "stat-title" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "chart-container" }
const _hoisted_8 = {
  ref: "chartRef",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("h1", null, "个人减肥记录"),
      _createElementVNode("p", { class: "page-subtitle" }, "健康生活，从记录开始")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "stat-card",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(stat.icon), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(stat.title), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(stat.value), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "chart-header" }, [
        _createElementVNode("h2", null, "体重变化趋势"),
        _createElementVNode("p", { class: "chart-subtitle" }, "追踪你的减肥进度")
      ], -1)),
      _createElementVNode("div", _hoisted_8, null, 512)
    ])
  ]))
}